<div
  fxLayout="row"
  fxLayoutAlign="space-between center"
  class="top-container"
  fxLayoutGap="8px"
>
  <img
    *ngIf="sidebarToggle !== true"
    (click)="toggleSideNav()"
    [src]="customerLogo"
    onError="this.src = '/assets/images/logos/LSS_LogoSmall.svg'"
    class="image__small"
  />
  <img
    *ngIf="sidebarToggle === true"
    class="image__large"
    (click)="toggleSideNav()"
    [src]="customerLogoLarge"
    onError="this.src = '/assets/images/logos/LSS_LogoSmall.svg'"
  />

  <div
    class="top-container__picture picture"
    [ngClass]="{ 'picture--noLogo': !logo }"
  >
    <button mat-icon-button (click)="toggleSideNav()" fxHide.xs="true">
      <mat-icon>menu</mat-icon>
    </button>

    <div class="bar-title">
      {{ titleLabel$ | async }}
    </div>
  </div>
</div>
